module.exports = __webpack_public_path__ + "img/3.fe95d405.jpg";